import { APICallV3Get } from 'reactApp/api/APICall';

export class BillingInfoAPICall extends APICallV3Get {
    _method = 'billing/info';
}
